import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.partOnlineOrderEligibility,
    sections: [
        createInvalidPartSection(),
        {
            sectionKey: 'invalidOnlineOrderEligibility',
            sectionTitle: 'Invalid Online Order Eligibility Values',
            invalidityCode: PreventionInvalidityCode.INVALID_BOOLEAN,
            fields: [
                {
                    key: 'partNumber',
                    label: 'Part Number',
                    type: 'text',
                    extractValue: (o) => typeof o === 'string' ? o : o?.partNo ?? null,
                    modifyRow: (row, val) => ({...row, partNumber: val}),
                },
                {
                    key: 'eligibleForOnlineOrdering',
                    label: 'Eligible For Online Ordering',
                    type: 'toggle',
                    modifyRow: (row, val) => ({...row, eligibleForOnlineOrdering: val}),
                },
            ],
        },
    ],
};
